module.exports = __webpack_public_path__ + "static/media/5.94201422.jpg";